export default __webpack_public_path__ + "static/logo6-b8fd89388160baecd1ceeecedda9bc53.svg";